import { useWatch, type UseFormReturn } from "react-hook-form";

import { type UpdateGamificationFormData } from "../../validations/gamification.validation";

export function usePendingSegmentation(
  form: UseFormReturn<UpdateGamificationFormData>,
): boolean {
  const cpfs: string[] | undefined = useWatch({
    control: form.control,
    name: "segmentationCpfs",
  });
  const isDirty: boolean = form.getFieldState(
    "segmentationCpfs",
    form.formState,
  ).isDirty;
  return isDirty && (cpfs ?? []).length > 0;
}
